import { ProductRequestDetailPage } from "@/features/consignment-product-request/pages/ProductRequestDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/consignment-product-request/$id/detail",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["vendor_consignment.view", "vendor_consignment.edit"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: ProductRequestDetailPage,
});
